module.exports = __webpack_public_path__ + "img/11.814bdea3.png";